import React from 'react';
import './CV.css';

function CV() {
  return (
    <div className="cv-container">
      <h1>Seiji Yonehara</h1>
      <p>b. 1973 Osaka, Japan</p>

      <h2>Education</h2>
      <p>Graduated from the Academy of Art University, San Francisco, California, 1997</p>

      <h2>Selected Exhibitions/Art Fairs</h2>
      <ul>
        <li>2024 Art in the Barn 2024, Barrington, IL</li>
        <li>2025 Minneapolis Sculpture Garden Art Fair 2025, Minneapolis, Minnesota</li>
        <li>2025 MSU 61st Annual Spring Arts & Crafts Show 2025, East Lansing, Michigan</li>
        <li>2025 Traverse City Spring Art & Craft Show, Traverse City, Michigan</li>
        <li>2025 Hinsdale Fine Arts Festival 2025, Hinsdale, Illinois</li>
        <li>2025 South Haven Art Fair 2025, South Haven, Michigan</li>
        {/* <li>2025 Akron Art Expo 2025, Akron, Ohio</li> */}
        <li>2025 Morning Glory Art Fair 2025, Milwaukee, Wisconsin</li>
        {/* <li>2025 Grand Traverse Bay Summer Art & Craft Show, Traverse City, Michigan</li> */}
        <li>2025 Art Fair on the Square 2025 - Lake Forest, Lake Forest, Illinois</li>
        <li>2025 Downers Grove Fine Arts Festival 2025, Downers Grove, Illinois</li>
        <li>2025 Art in the Barn 2025, Barrington, Illinois</li>
      </ul>

      <h2>Awards</h2>
      <ul>
        <li>2024 Best Of Oil at Art in the Barn, Barrington, IL</li>
      </ul>
    </div>
  );
}

export default CV;